module.exports = __webpack_public_path__ + "static/media/header-bg.114d5935.png";